import {MyopMessages} from "../../common/MyopMessages";
import {ShadowRootRef} from "../shadowRootRef";
import {BaseWebComponentMessageHandler} from "./BaseWebComponentMessageHandler";
import {MyopElementMessage} from "../../messages";
import {getElementsByRef} from "../../common/messageHandlers/helpers";

export class ChangeTextHandler extends BaseWebComponentMessageHandler<MyopElementMessage> {

    messageType = MyopMessages.ChangeTextMessage;

    innerExecutor = (event: MyopElementMessage, shadowRootRef: ShadowRootRef) => {
        const items = getElementsByRef(event.ref, shadowRootRef.shadowRoot);
        items.forEach(item => {
            item.textContent = event.content;
        })
    }
}
